import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Menu.svg?component
var Menu_exports = /* @__PURE__ */ __exportAll({
	default: () => Menu_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M22 6.8H2m20 10.4H2"
	}, null, -1)])]);
}
var Menu_default = { render: render$1 };
//#endregion
export { Menu_exports, Menu_default as default, render$1 as render };

//# sourceMappingURL=Menu.svg_component.js.map